import { call } from 'redux-saga/effects';
import { APIS } from '../../_config';
import { CallApi } from '../api/callApi';

export function* GetMyDashboardWROverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WR_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardTasksOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_TASKS_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardResponsivenessByFarm(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_RESPONSIVENESS_BY_FARM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardResponsivenessIndividual(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_RESPONSIVENESS_INDIVIDUAL, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetMyDashboardReactiveByFarm(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_BY_FARM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardReactiveOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardPMByFarm(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_PM_BY_FARM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardPMOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_PM_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetMyDashboardWalkthroughsByFarm(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGHS_BY_FARM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetMyDashboardWalkthroughsOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGHS_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAdoptionDashboardCounts(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ADOPTION_DASHBOARD_COUNTS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

function* kpiExportSaga(action: any, apiKey: string): any {
    try {
        const resp = yield call(CallApi.GET, (APIS.DASHBOARD as any)[apiKey], action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportKpiTotalWRsToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_TOTAL_WRS_PDF'); }
export function* ExportKpiTotalWRsToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_TOTAL_WRS_XLS'); }
export function* ExportKpiAvgTasksToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_TASKS_PDF'); }
export function* ExportKpiAvgTasksToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_TASKS_XLS'); }
export function* GetCompletedWOsWithoutRootCause(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_COMPLETED_WOS_WITHOUT_ROOT_CAUSE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data.message : '');
    }
}
export function* ExportCompletedWOsWithoutRootCauseToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_PDF'); }
export function* ExportCompletedWOsWithoutRootCauseToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_XLS'); }
export function* ExportKpiAvgHoursToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_HOURS_PDF'); }
export function* ExportKpiAvgHoursToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_AVG_HOURS_XLS'); }
export function* ExportKpiChecklistTasksToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_TASKS_PDF'); }
export function* ExportKpiChecklistTasksToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_TASKS_XLS'); }
export function* ExportKpiChecklistCompletionToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_COMPLETION_PDF'); }
export function* ExportKpiChecklistCompletionToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_KPI_CHECKLIST_COMPLETION_XLS'); }

export function* ExportManagerKpiWRsWithoutTaskToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_PDF'); }
export function* ExportManagerKpiWRsWithoutTaskToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_XLS'); }
export function* ExportManagerKpiTasksWithoutAssignmentToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_PDF'); }
export function* ExportManagerKpiTasksWithoutAssignmentToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_XLS'); }
export function* ExportManagerKpiTasksWithoutScheduleToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_PDF'); }
export function* ExportManagerKpiTasksWithoutScheduleToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_XLS'); }
export function* ExportManagerKpiTasksNotCompletedToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_PDF'); }
export function* ExportManagerKpiTasksNotCompletedToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_XLS'); }
export function* ExportWRsWithoutTaskByPriorityToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_PDF'); }
export function* ExportWRsWithoutTaskByPriorityToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_XLS'); }

export function* ExportAdoptionCountsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ADOPTION_COUNTS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAdoptionCountsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ADOPTION_COUNTS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkRequestOrigins(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WORK_REQUEST_ORIGINS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetTaskOriginsGallus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_TASK_ORIGINS_GALLUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetGrowerTaskOrigins(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_GROWER_TASK_ORIGINS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetUserActivitySummary(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_USER_ACTIVITY_SUMMARY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWRStatusPieChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WR_STATUS_PIE_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRStatusPieChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRStatusPieChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockAdjustmentChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_STOCK_ADJUSTMENT_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetInventoryMovementChart(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_INVENTORY_MOVEMENT_CHART, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardWRKPIs(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_WR_KPIS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardWR(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_WR, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardTeam(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_TEAM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardPurchasing(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_PURCHASING, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerDashboardAssets(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_DASHBOARD_ASSETS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetReliabilityMatrixData(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_RELIABILITY_MATRIX_DATA, {}, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetLowStockReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_LOW_STOCK_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWarrantiesReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WARRANTIES_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetsTimeCostReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ASSETS_TIME_COST_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAssetsUptimeReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_ASSETS_UPTIME_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetClosedTasksReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_CLOSED_TASKS_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWorkRequestOriginsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWorkRequestOriginsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGrowerTaskOriginsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGrowerTaskOriginsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportUserActivitySummaryToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportUserActivitySummaryToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWRCompletenessByFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WR_COMPLETENESS_BY_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRCompletenessByFacilityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_COMPLETENESS_BY_FACILITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRCompletenessByFacilityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_COMPLETENESS_BY_FACILITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportInventoryMovementChartToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportInventoryMovementChartToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerWorkRequestsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerWorkRequestsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerPurchasingToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_PURCHASING_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerPurchasingToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_PURCHASING_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskOriginsGallusToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskOriginsGallusToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerHoursByFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetManagerHoursByFacilityLP(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY_LP, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityLPToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_HOURS_BY_FACILITY_LP_PDF'); }
export function* ExportManagerHoursByFacilityLPToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_HOURS_BY_FACILITY_LP_XLS'); }

export function* GetManagerHoursByFacilityRM(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY_RM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportManagerHoursByFacilityRMToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_HOURS_BY_FACILITY_RM_PDF'); }
export function* ExportManagerHoursByFacilityRMToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MANAGER_HOURS_BY_FACILITY_RM_XLS'); }

export function* ExportTasksAgingPriorityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWRsWithoutTaskByPriority(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_WRS_WITHOUT_TASK_BY_PRIORITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetTasksAndWRsByFacility(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_TASKS_AND_WRS_BY_FACILITY, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTasksAndWRsByPriorityToPDF(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AND_WRS_BY_PRIORITY_PDF, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTasksAndWRsByPriorityToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AND_WRS_BY_PRIORITY_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetScheduledTasksByFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_SCHEDULED_TASKS_BY_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportScheduledTasksDetailToPDF(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_SCHEDULED_TASKS_DETAIL_PDF, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportScheduledTasksDetailToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_SCHEDULED_TASKS_DETAIL_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetTotalResponseTime(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_TOTAL_RESPONSE_TIME, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTotalResponseTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_TOTAL_RESPONSE_TIME_PDF'); }
export function* ExportTotalResponseTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_TOTAL_RESPONSE_TIME_XLS'); }

export function* ExportTasksAgingPriorityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRByPriorityToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_BY_PRIORITY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWRByPriorityToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WR_BY_PRIORITY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskFunnelToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_FUNNEL_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskFunnelToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_FUNNEL_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportHighPriorityWRsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_HIGH_PRI_WRS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportHighPriorityWRsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_HIGH_PRI_WRS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCreationTimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_CREATION_TIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCreationTimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_CREATION_TIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCompletionTimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportTaskCompletionTimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportCompletedTasksByEmployeeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_COMPLETED_TASKS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportCompletedTasksByEmployeeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_COMPLETED_TASKS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetCompletedTasksByFarm(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_COMPLETED_TASKS_BY_FARM, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportCompletedTasksByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_FARM_PDF'); }
export function* ExportCompletedTasksByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_FARM_XLS'); }

export function* GetCompletedTasksByRM(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_COMPLETED_TASKS_BY_RM, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportCompletedTasksByRMToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_RM_PDF'); }
export function* ExportCompletedTasksByRMToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_RM_XLS'); }

export function* GetCompletedTasksByLP(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_COMPLETED_TASKS_BY_LP, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportCompletedTasksByLPToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_LP_PDF'); }
export function* ExportCompletedTasksByLPToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_LP_XLS'); }

export function* GetCompletedTasksByGrower(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_COMPLETED_TASKS_BY_GROWER, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportCompletedTasksByGrowerToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_GROWER_PDF'); }
export function* ExportCompletedTasksByGrowerToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_COMPLETED_TASKS_BY_GROWER_XLS'); }

export function* GetLoggedHoursByRM(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_LOGGED_HOURS_BY_RM, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportLoggedHoursByRMToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_RM_PDF'); }
export function* ExportLoggedHoursByRMToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_RM_XLS'); }

export function* GetLoggedHoursByLP(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_LOGGED_HOURS_BY_LP, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportLoggedHoursByLPToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_LP_PDF'); }
export function* ExportLoggedHoursByLPToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_LP_XLS'); }

export function* GetLoggedHoursByGrower(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_LOGGED_HOURS_BY_GROWER, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportLoggedHoursByGrowerToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_GROWER_PDF'); }
export function* ExportLoggedHoursByGrowerToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_LOGGED_HOURS_BY_GROWER_XLS'); }

export function* ExportLoggedHoursByEmployeeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOGGED_HOURS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLoggedHoursByEmployeeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOGGED_HOURS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPMReactiveToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PM_REACTIVE_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPMReactiveToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PM_REACTIVE_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetChecklistByCreator(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_CHECKLIST_BY_CREATOR, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportChecklistByCreatorToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_CHECKLIST_BY_CREATOR_PDF'); }
export function* ExportChecklistByCreatorToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_CHECKLIST_BY_CREATOR_XLS'); }

export function* GetPurchasingMethodByWO(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_PURCHASING_METHOD_BY_WO, action.payload, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else { action && action.callbackError && action.callbackError(resp.data?.message); }
    } catch (e: any) { action && action.callbackError && action.callbackError(e && e.data ? e.data : e); }
}
export function* ExportPurchasingMethodCountToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_PURCHASING_METHOD_COUNT_PDF'); }
export function* ExportPurchasingMethodCountToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_PURCHASING_METHOD_COUNT_XLS'); }
export function* ExportPurchasingMethodValueToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_PURCHASING_METHOD_VALUE_PDF'); }
export function* ExportPurchasingMethodValueToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_PURCHASING_METHOD_VALUE_XLS'); }

export function* ExportPurchasingMethodToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_METHOD_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingMethodToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_METHOD_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingSpendToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_SPEND_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchasingSpendToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASING_SPEND_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGoodsOnOrderToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GOODS_ON_ORDER_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportGoodsOnOrderToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_GOODS_ON_ORDER_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchaseReceiptsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASE_RECEIPTS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportPurchaseReceiptsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_PURCHASE_RECEIPTS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowInventoryToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_INVENTORY_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowInventoryToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_INVENTORY_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportDownAssetsToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_DOWN_ASSETS_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportMyDashboardWROverTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_OVER_TIME_PDF'); }
export function* ExportMyDashboardWROverTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_OVER_TIME_XLS'); }
export function* ExportMyDashboardTasksOverTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_PDF'); }
export function* ExportMyDashboardTasksOverTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_XLS'); }
export function* ExportMyDashboardRespByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_RESP_BY_FARM_PDF'); }
export function* ExportMyDashboardRespByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_RESP_BY_FARM_XLS'); }
export function* ExportMyDashboardRespIndToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_RESP_IND_PDF'); }
export function* ExportMyDashboardRespIndToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_RESP_IND_XLS'); }
export function* ExportMyDashboardWalkByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WALK_BY_FARM_PDF'); }
export function* ExportMyDashboardWalkByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WALK_BY_FARM_XLS'); }
export function* ExportMyDashboardWalkOverTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WALK_OVER_TIME_PDF'); }
export function* ExportMyDashboardWalkOverTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WALK_OVER_TIME_XLS'); }
export function* ExportMyDashboardPMByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_PM_BY_FARM_PDF'); }
export function* ExportMyDashboardPMByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_PM_BY_FARM_XLS'); }
export function* ExportMyDashboardPMOverTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_PM_OVER_TIME_PDF'); }
export function* ExportMyDashboardPMOverTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_PM_OVER_TIME_XLS'); }
export function* ExportMyDashboardReactiveByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_PDF'); }
export function* ExportMyDashboardReactiveByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_XLS'); }
export function* ExportMyDashboardReactiveOverTimeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_PDF'); }
export function* ExportMyDashboardReactiveOverTimeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_XLS'); }
export function* GetMyDashboardWRByFacilityOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WR_BY_FACILITY_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportMyDashboardWRByFacilityOTToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_PDF'); }
export function* ExportMyDashboardWRByFacilityOTToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_BY_FACILITY_OT_XLS'); }

export function* GetMyDashboardTasksByFacilityOverTime(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_TASKS_BY_FACILITY_OVER_TIME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportMyDashboardTasksByFacilityOTToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_PDF'); }
export function* ExportMyDashboardTasksByFacilityOTToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_TASKS_BY_FACILITY_OT_XLS'); }

export function* GetMyDashboardWRCompletenessByFarm(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportMyDashboardWRCompletenessByFarmToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_PDF'); }
export function* ExportMyDashboardWRCompletenessByFarmToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_FARM_XLS'); }

export function* GetMyDashboardWRCompletenessByMe(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.GET_MY_DASHBOARD_WR_COMPLETENESS_BY_ME, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportMyDashboardWRCompletenessByMeToPDF(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_PDF'); }
export function* ExportMyDashboardWRCompletenessByMeToXLS(action: any): any { yield* kpiExportSaga(action, 'EXPORT_MY_DASHBOARD_WR_COMPLETENESS_BY_ME_XLS'); }

export function* ExportDownAssetsToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_DOWN_ASSETS_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetDowntimeToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSET_DOWNTIME_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetDowntimeToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSET_DOWNTIME_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMttrMtbfToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MTTR_MTBF_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportMttrMtbfToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_MTTR_MTBF_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportReliabilityMatrixToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportReliabilityMatrixToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportExpiringWarrantiesToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportExpiringWarrantiesToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetsUptimeReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSETS_UPTIME_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportAssetsTimeCostReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_ASSETS_TIME_COST_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportWarrantiesReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_WARRANTIES_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportLowStockReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_LOW_STOCK_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportClosedTasksReportToXLS(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.DASHBOARD.EXPORT_CLOSED_TASKS_REPORT_XLS, action.payload, true, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
